<template>
  <section class="app-main">
	  <span @click="back" v-if="$store.state.isBack" class="pageBack">{{$t('page.back')}}</span>
	  <el-breadcrumb separator="/" class="breadcrumb" id="breadcrumb">
	    <el-breadcrumb-item><b style="color: #222222;">{{getPageTitle($store.state.pageTitle)}}</b></el-breadcrumb-item>
	    <!-- <el-breadcrumb-item><a href="/">活动管理</a></el-breadcrumb-item> -->
	  </el-breadcrumb>
    <transition name="fade-transform" mode="out-in">
      <router-view></router-view>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    // key() {
    //   return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    // }
  },
  methods:{
	  getPageTitle(title){
		  return this.$t(`menu.${title}`)
	  },
	  back(){
		  this.$router.go(-1)
	  },
  }
}
</script>
<style scoped>
.app-main {
	background-color: #F1F1F1;
	padding: 0 20px;
	position: relative;
  /*84 = navbar + tags-view = 50 +34 */
  /*min-height: calc(80vh - 84px);*/
  /* height: 93vh;
  position: relative;
  overflow-y: auto; */
}
.breadcrumb{
	padding: 20px 0;
	font-size: 18px;
	font-weight: bold;
}
.breadcrumb .el-breadcrumb__inner{
	font-weight: bold;
}
.pageBack{
	position: absolute;
	right: 24px;
	top: 15px;
	font-size: 15px;
	line-height: 28px;
	color: #388CFF;
	cursor: pointer;
}
</style>
